import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getSourceNomenclature } from 'Utils/nomenclature';
import { getDataSourceById, toUiDataSource } from '../DataSources/datasourcesApi';
import SalesforceObjectDetail from './SalesforceNetwork/ObjectDetail';
import { useObjectChoice } from './SalesforceNetwork/objectChoice';
import './styles.css';

const objectPath = (dataSourceId, table) =>
  `/metadata/source/${encodeURIComponent(dataSourceId)}/object/${encodeURIComponent(table)}`;

/**
 * One Salesforce object on the Fingerprint side (/metadata/source/:dataSourceId/object/:objectName).
 * It carries the source's Discover choice (config.selectedObjects; since 2026-11-04 edited here and on
 * the Fingerprint page's list, not on a data graph): the same bar as the list, plus Add / Remove for
 * this object. An unsaved choice carries over to and from the list. The body is shared with the Data
 * Graph's object page.
 */
const SalesforceObjectPage = () => {
  const { dataSourceId, objectName: objectParam } = useParams();
  const objectName = decodeURIComponent(objectParam);
  const history = useHistory();
  const [source, setSource] = useState(null);
  const sourceName = source ? source.name : null;

  useEffect(() => {
    let cancelled = false;
    getDataSourceById(dataSourceId)
      .then((dto) => { if (!cancelled && dto) setSource(toUiDataSource(dto)); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [dataSourceId]);

  const choice = useObjectChoice({
    dataSourceId, source, onSaved: (list) => setSource((prev) => ({ ...(prev || {}), selectedObjects: list })),
  });

  return (
    <div className='metadata-page'>
      <div className='metadata-toolbar'>
        <span className='mt-title'>OBJECT DETAIL</span>
        <span className='mt-sep'>|</span>
        <button
          type='button'
          className='metadata-sortbtn'
          data-testid='sf-object-back'
          onClick={() => history.push('/metadata/source/' + encodeURIComponent(dataSourceId))}
        >
          ← Back to {sourceName || 'data source'}
        </button>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: 16, background: '#fff' }}>
        <SalesforceObjectDetail
          dataSourceId={dataSourceId}
          objectName={objectName}
          nouns={getSourceNomenclature('salesforce')}
          choice={choice}
          onOpenObject={(table) => history.push(objectPath(dataSourceId, table))}
        />
      </div>
    </div>
  );
};

export default SalesforceObjectPage;
